import React from "react";

import {
  FaUserGraduate,
  FaChalkboardTeacher,
  FaBookOpen,
  FaAward,
  FaArrowRight,
} from "react-icons/fa";


import girlStudent from "./images/girllll.jpg";
import happyStudents from "./images/grilwritinggg.jpg";
import libraryStudent from "./images/janagirl.jpg";
import teacherStudent from "./images/janaw.jpg";


import "./CardJana.css";



const featureCards = [

  {
    id:1,
    image:girlStudent,
    icon:<FaUserGraduate />,
    title:"Quality Education",
    description:
    "We provide a well-rounded education that nurtures academic excellence, character, leadership, and lifelong learning in every student.",
  },


  {
    id:2,
    image:happyStudents,
    icon:<FaBookOpen />,
    title:"Modern Learning",
    description:
    "Our engaging classrooms, innovative teaching methods, and digital resources inspire creativity, curiosity, and confidence.",
  },


  {
    id:3,
    image:libraryStudent,
    icon:<FaChalkboardTeacher />,
    title:"Experienced Teachers",
    description:
    "Our qualified and passionate educators are committed to guiding students toward academic success and personal growth.",
  },


  {
    id:4,
    image:teacherStudent,
    icon:<FaAward />,
    title:"Excellence & Integrity",
    description:
    "We cultivate discipline, integrity, leadership, and excellence while preparing students to become responsible global citizens.",
  },

];




const Card = () => {


return (

<section className="mmi-feature-section">


<div className="mmi-feature-header">


<span className="mmi-section-badge">
Why Choose Us
</span>



<h2 className="mmi-section-title">

Building Tomorrow's Leaders Through

<span>
Excellence in Education
</span>

</h2>



<p className="mmi-section-description">

Excellent Kids Foundation provides a nurturing environment
where every child is empowered academically, socially,
and morally to become a confident leader of tomorrow.

</p>



</div>




<div className="mmi-feature-grid">


{
featureCards.map((item)=>(


<div
key={item.id}
className="mmi-feature-card"
>


<div className="mmi-card-image-wrapper">


<img
src={item.image}
alt={item.title}
className="mmi-card-image"
/>



<div className="mmi-card-overlay"></div>



<div className="mmi-card-icon">

{item.icon}

</div>



</div>





<div className="mmi-card-content">


<h3 className="mmi-card-title">

{item.title}

</h3>



<p className="mmi-card-text">

{item.description}

</p>




<button className="mmi-card-button">

Learn More

<FaArrowRight />

</button>



</div>


</div>


))
}



</div>



</section>


);


};



export default Card;


